import { useCallback, useContext, useEffect } from 'react';
import type { BrandInsightsPageContext } from '@trinity/chat';
import { DispatchPageContextDataContext } from '../context';

export function useRegisterChatPageContext() {
  const setChatContext = useContext(DispatchPageContextDataContext);

  useEffect(() => {
    return () => {
      if (!setChatContext) {
        console.log('No chat context dispatcher found on unmount');
      }
      setChatContext?.(null);
    };
  }, [setChatContext]);

  return useCallback((context: BrandInsightsPageContext.Item) => {
    if (!setChatContext) {
      console.log('No chat context dispatcher found when setting context');
    }
    setChatContext?.(context);
  }, [setChatContext]);
}